import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { transparentize } from "polished";
import { convertLayoutProps } from "../../utils";
var TextWithRef = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var tmp = props.as, Element = tmp === void 0 ? "p" : tmp, children = props.children, restProps = _object_without_properties(props, [
        "as",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Element, _object_spread_props(_object_spread({
        ref: ref
    }, restProps), {
        children: children
    }));
});
TextWithRef.displayName = "TextWithRef";
var Text = styled(TextWithRef).withConfig({
    componentId: "sc-cc515bd7-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $variant = param.$variant;
    return theme.expandVariants($variant, theme.typography.paragraphs);
}, function(_param) {
    var theme = _param.theme, $styles = _param.$styles, $align = _param.$align, _$color = _param.$color, $color = _$color === void 0 ? "primaryIndigo" : _$color, _$transparency = _param.$transparency, $transparency = _$transparency === void 0 ? 0 : _$transparency, props = _object_without_properties(_param, [
        "theme",
        "$styles",
        "$align",
        "$color",
        "$transparency"
    ]);
    return theme.normalizeStyles(_object_spread(_object_spread_props(_object_spread({}, convertLayoutProps(props)), {
        color: $transparency ? transparentize($transparency, theme.colors[$color]) : theme.colors[$color],
        textAlign: $align
    }), $styles));
});
Text.displayName = "Text";
export default Text;
